import React from 'react';
import { Card, AppBar, Divider, Typography } from '@material-ui/core';

class OrderedSchedule extends React.Component {

    render() {
        const eventList = !!this.props.events ? this.props.events.map((event) => {
            const eventType = event.eventType === 'assignment' ? 'Assignment' : 'Quiz';
            return (
                <tr key={event.id}>
                    <td>{eventType}</td>
                    <td>{event.title}</td>
                </tr>
            )
        }) : null

        return (
            <div style={{ paddingBottom: '15px' }}>
                <Card>
                    <AppBar position="static">
                        <div className="p-16 pr-4 flex flex-row items-center justify-between">
                            <Typography className="h3 pr-16" color="inherit">Schedule List</Typography>
                        </div>
                    </AppBar>
                    <table className="simple">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventList}
                        </tbody>
                    </table>
                    <Divider className="card-divider w-full" />
                </Card>


            </div>
        );
    }
}

export default OrderedSchedule;


// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/OrderedSchedule.js